// Packages
import { createApp, defineAsyncComponent } from 'vue';

// Vue components
import SearchList from '@vue-components/SearchList.vue';

// Modules
import { applyOfferCodes } from '@modules/quoteLinks';

export default function init(): void {
  const el = document.querySelector<HTMLElement>('#search-index')!;

  // Create Vue instance for people search
  const vueInstance = createApp({
    name: 'SearchIndex',
    compilerOptions: {
      delimiters: ['${', '}'],
    },
    components: {
      SearchList,
      InsightCard: defineAsyncComponent(() => import('@vue-components/cards/InsightCard.vue')),
      VideoCard: defineAsyncComponent(() => import('@vue-components/cards/VideoCard.vue')),
    },
    mounted() {
      this.applyOfferCodes();
    },
    updated() {
      this.applyOfferCodes();
    },
    methods: {
      applyOfferCodes() {
        applyOfferCodes([...el.querySelectorAll<HTMLAnchorElement>('.quote-link')]);
      },
    },
  });

  // Mount the app
  vueInstance.mount(el);
}
